import { useQuery } from '@apollo/client';
import { GET_WAREHOUSES } from '../graphql/queries';

export const useWarehouses = () => {
  const { data, loading, error } = useQuery(GET_WAREHOUSES);

  return {
    warehouses: data?.warehouseList || [],
    loading,
    error,
  };
};
